// extracted by mini-css-extract-plugin
module.exports = {"buttonArea":"TableContextMenu_buttonArea__35ept","tableMenuButton":"TableContextMenu_tableMenuButton__2ZqL6","tableMenuIcon":"TableContextMenu_tableMenuIcon__1PGpz"};